module.exports = __webpack_public_path__ + "222cffacb08f452c2edafa13e6a8eed2.pdf";